import { ProjectStatusDTO } from '../types/dto/project-status.dto';
import { ProjectStatus } from '../types/project';

/**
 * Maps project status DTO to application enum.
 */
export const mapProjectStatusFromDTO = (dto: ProjectStatusDTO): ProjectStatus => {
  switch (dto) {
    case ProjectStatusDTO.TENTATIVE:
      return ProjectStatus.Tentative;
    case ProjectStatusDTO.ACTIVE:
      return ProjectStatus.Active;
    case ProjectStatusDTO.ARCHIVED:
      return ProjectStatus.Archived;
    default:
      return ProjectStatus.Active; // Fallback
  }
};

/**
 * Maps application enum to project status DTO.
 */
export const mapProjectStatusToDTO = (status: ProjectStatus): ProjectStatusDTO => {
  switch (status) {
    case ProjectStatus.Tentative:
      return ProjectStatusDTO.TENTATIVE;
    case ProjectStatus.Active:
      return ProjectStatusDTO.ACTIVE;
    case ProjectStatus.Archived:
      return ProjectStatusDTO.ARCHIVED;
    default:
      return ProjectStatusDTO.ACTIVE; // Fallback
  }
};
